import {
  SSOErrorDialog,
  useShouldShowSSOErrorDialog,
} from 'app/components/dialogs/SSOErrorDialog';
import React, { createContext, useContext } from 'react';
import { Context } from './types';
import {
  SetUserNamesDialog,
  useShouldShowSetUserNamesDialog,
} from 'app/components/dialogs/SetUserNamesDialog';

const DialogManagerContext = createContext<Context>({} as Context);

interface Props {
  children: React.ReactNode;
}

export function DialogManagerProvider({ children }: Props) {
  const ssoErrorDialog = useShouldShowSSOErrorDialog();
  const setUserNamesDialog = useShouldShowSetUserNamesDialog();

  const value = {
    ssoErrorDialog,
    setUserNamesDialog,
  };

  return (
    <DialogManagerContext.Provider value={value}>
      {children}

      {ssoErrorDialog.isOpen && (
        <SSOErrorDialog
          errorDescription={ssoErrorDialog.error.errorDescription}
          onClose={ssoErrorDialog.close}
        />
      )}

      {setUserNamesDialog.isOpen && (
        <SetUserNamesDialog
          onDismiss={setUserNamesDialog.onDismiss}
          onSuccess={setUserNamesDialog.onSuccess}
        />
      )}
    </DialogManagerContext.Provider>
  );
}

const useDialogManagerContext = () => useContext(DialogManagerContext);
export default useDialogManagerContext;
